import { LocalStorage } from 'quasar';
import { Option } from 'src/models/models';
export interface UserStateInterface {
  identifier?: string;
  type?: string;
  state: Option[] | null;
  district: Option[] | null;
  city: Option[] | null;
  next?: string;
  loading: boolean;
  firstTime: boolean;
}

export function stateInit(): UserStateInterface {
  const state = LocalStorage.getItem('state') as Option[];
  const district = LocalStorage.getItem('district') as Option[];
  const city = LocalStorage.getItem('city') as Option[];
  return {
    identifier: undefined,
    type: undefined,
    state: state
      ? state
      : [
          {
            label: 'Región Metropolitana de Santiago',
            value: 'Región Metropolitana de Santiago'
          }
        ],
    district: district ? district : [{ label: 'Santiago', value: 'Santiago' }],
    city: city ? city : [{ label: 'Santiago', value: 'Santiago' }],
    next: LocalStorage.getItem('next') as string,
    loading: true,
    firstTime:
      LocalStorage.getItem('firstTime') === null
        ? true
        : (LocalStorage.getItem('firstTime') as boolean)
  };
}
